import React, { useState, Fragment } from "react";
import {
  Grid,
  BottomNavigation,
  BottomNavigationAction,
  makeStyles,
} from "@material-ui/core";
import { Link } from "react-router-dom";
import { useLocation } from "react-router-dom";
// Importation des icones
/*import HomeOutlinedIcon from "@material-ui/icons/HomeOutlined";
import Person from "@material-ui/icons/Person";
import Add from "@material-ui/icons/Add";
import { Icon } from "@iconify/react";
import trophyOutline from "@iconify-icons/mdi/trophy-outline";*/
// Icones footer
import pictoHome from "../images/pictos/001-home.png";
import pictoTrophy from "../images/pictos/002-trophy.png";
import pictoAdd from "../images/pictos/004-add.png";
import pictoUser from "../images/pictos/003-user.png";
// Importation des logos
import logoADB from "../images/logos/logoADB.jpg";
import logoAriege from "../images/logos/logoAriege.png";
import logoAriegeTourisme from "../images/logos/logoAriegeTourisme.jpg";
import logoPoctefa from "../images/logos/logoPoctefa.jpg";
import logoUnivGirona from "../images/logos/logoUnivGirona.png";
import logoUT2J from "../images/logos/logoUT2J.png";
import euflag from "../images/logos/eu_flag.png";

const useStyles = makeStyles((theme) => ({
  footer: {
    backgroundColor: "#393838",
    borderTopLeftRadius: 15,
    borderTopRightRadius: 15,
    height: 75,
  },
  icon: {
    color: "#fff",
    padding: 0,
    textTransform: "uppercase",
    lineHeight: "1.5rem",

    fontWeight: "Bold",
    fontSize: "0.75rem",
  },
  logo: {
    height: "20.8px",
    margin: "0 1%",
    backgroundColor: "white",
  },
  logofoot: {
    height: "25px",
    padding: "0 4px",
    filter: "invert(100%)",
  },
  texticonnav: {
    fontSize: "10px",
  },
  selected: {
    color: "#E50039",
  },
}));

const Footer = () => {
  const [value, setValue] = useState(2);

  const classes = useStyles();
  const location = useLocation();

  const ListeLogos = () => {
    if (location.pathname === "/observation") {
      setValue(2);
    }

    if (location.pathname === "/") {
      return (
        <section
          style={{
            height: "4vh",
            display: "flex",
            justifyContent: "space-around",
            marginTop: "auto",
            padding: "0px 1vh",
            margin: "0.5vh",
          }}
        >
          <img
            className={classes.logo}
            src={logoPoctefa}
            alt="Logo de l'Interreg Poctefa"
          />
          <img
            className={classes.logo}
            src={logoUnivGirona}
            alt="Logo de l'université de Girona"
          />
          <img
            className={classes.logo}
            src={logoAriege}
            alt="Logo du département de l'Ariège"
          />
          <img className={classes.logo} src={euflag} alt="Logo de l'UE" />

          <img
            className={classes.logo}
            src={logoADB}
            alt="Logo de développement de Bergueda"
          />
          <img
            className={classes.logo}
            src={logoUT2J}
            alt="Logo de l'Université Toulouse Jean-Jaures"
          />
          <img
            className={classes.logo}
            src={logoAriegeTourisme}
            alt="Logo de l'Ariège pour la promotion du tourisme"
          />
        </section>
      );
    } else {
      return <Fragment></Fragment>;
    }
  };

  return (
    <footer style={{ overflow: "hidden" }}>
      <Grid container spacing={2}>
        <ListeLogos
          classes={{ label: "texticonnav", selected: classes.selected }}
        />
        {/* Ligne du menu en footer */}
        <Grid item xs={12}>
          <BottomNavigation
            value={value}
            onChange={(event, newValue) => {
              setValue(newValue);
            }}
            showLabels
            className={classes.footer}
          >
            <BottomNavigationAction
              component={Link}
              to="/"
              label="Accueil"
              classes={{ label: "texticonnav", selected: classes.selected }}
              icon={
                <img className={classes.logofoot} src={pictoHome} alt="Home" />
              }
              className={classes.icon}
            />
            <BottomNavigationAction
              component={Link}
              to="#awards"
              disabled
              label="Trophées"
              className={classes.icon}
              classes={{ label: "texticonnav" }}
              icon={
                <img
                  className={classes.logofoot}
                  src={pictoTrophy}
                  alt="Trophée"
                />
              }
              style={{
                filter: "brightness(50)",
                opacity: 0.5,
                cursor: "not-allowed",
              }}
            />
            <BottomNavigationAction
              component={Link}
              to="/observation"
              label="Ajouter"
              classes={{ label: "texticonnav" }}
              icon={
                <img
                  className={classes.logofoot}
                  src={pictoAdd}
                  alt="Ajouter"
                />
              }
              className={classes.icon}
            />
            <BottomNavigationAction
              component={Link}
              to="/user"
              label="Mon compte"
              classes={{ label: "texticonnav" }}
              icon={
                <img
                  className={classes.logofoot}
                  src={pictoUser}
                  alt="Mon Compte"
                />
              }
              className={classes.icon}
            />
          </BottomNavigation>
        </Grid>
      </Grid>
    </footer>
  );
};

export default Footer;
